import React, { ReactElement } from "react";

import { Icon, Link, Tooltip, Typography } from "components";

export type AdminHeadProps = {
  headline: string | ReactElement;
  description?: ReactElement | string;
  title?: string;
  extra?: ReactElement;
  tooltipText?: string;
  link?: string;
  className?: string;
};

export const AdminHead = ({ headline, title, description, link, extra, tooltipText, className = "" }: AdminHeadProps) => (
  <div className={className} style={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: "1rem" }}>
    <div style={{ flex: "1 1 320px", minWidth: 0 }}>
      <Typography variant="h2" style={{ margin: "0 0 1rem 0" }}>
        {link && (
          <Link to={link}>
            <Tooltip placement="right" title={tooltipText || ""}>
              <Icon iconName="tabler/arrow-left" className="icon margin-right-50 inline" size="m" style={{ transform: "translate3d(0, -0.25rem, 0)" }} />
            </Tooltip>
          </Link>
        )}
        {headline || title}
      </Typography>
      {description && (
        <Typography variant="paragraph-m" style={{ maxWidth: extra ? "768px" : "" }} color="grey-600">
          {description}
        </Typography>
      )}
    </div>
    {extra && (
      <div className="right" style={{ flex: "0 1 auto", maxWidth: "50%" }}>
        <div className="admin-extra">{extra}</div>
      </div>
    )}
  </div>
);

export default AdminHead;
